export default __webpack_public_path__ + "static/media/ret-res11.2f56e45e.jpg";